import { useContext } from "react";

import { SessionContext } from "./SessionManager";

export const useSession = () => useContext(SessionContext);
